import { cn } from '@rouvydev/web-components/utils'
import { cva, type VariantProps } from 'class-variance-authority'
import { type ReactNode } from 'react'
import { Icon } from '~/components/icon'

const socialsVariants = cva(
  'transform fill-icon-informative transition duration-300 hover:scale-125',
  {
    variants: {
      variant: {
        small: 'h-4 w-4',
        normal: 'h-6 w-6',
      },
    },
    defaultVariants: {
      variant: 'small',
    },
  },
)

export type SocialTypes =
  | 'strava'
  | 'facebook'
  | 'instagram'
  | 'x'
  | 'rouvy'
  | 'linkedin'

export type Props = VariantProps<typeof socialsVariants> & {
  socials: ({
    type: SocialTypes
    link: string
  } | null)[]
  className?: string
}

export function Socials({ socials, variant, className }: Props) {
  return (
    <div className={cn('flex flex-row gap-3', className)}>
      {socials.map((socialNetwork) => {
        if (!socialNetwork) return null
        return (
          <SocialLink
            key={socialNetwork.type}
            icon={
              <Icon
                className={cn(socialsVariants({ variant }))}
                name={socialNetwork.type as any}
              />
            }
            link={socialNetwork.link}
          />
        )
      })}
    </div>
  )
}

function SocialLink({ icon, link }: { icon: ReactNode; link: string }) {
  return (
    <a target="_blank" href={link} rel="noreferrer">
      {icon}
    </a>
  )
}
